<template>
  <div>
    <h1>Krankheitsübersicht</h1>
    <router-link class="btn btn-outline-info" :to="{ path: 'illnesses/illnessCreate' }">Krankheit Hinzufügen</router-link>
    <br />
    <br />
    <div v-if="illnesses.length > 0">
      <table class="table">
        <tr>
          <td>Nutzer</td>
          <td>Zeitraum</td>
          <td>Beschreibung</td>
          <td>AU</td>
          <td></td>
        </tr>
        <tr v-for="illness in illnesses" :key="illness.id">
          <td>{{ illness.user.name }}</td>
          <td>{{ moment(illness.from).format("DD.MM.yyyy") }} - {{ moment(illness.to).format("DD.MM.yyyy") }}</td>
          <td>{{ illness.description }}</td>
          <td>
            <!-- Show this button if it's not a digital sick note -->
            <a v-if="!illness.digitalSickNote" class="btn btn-info"
              @click.prevent="downloadfile(illness.id, illness.filePath)">
              AU Herunterladen
            </a>
            <!-- Display this text if it's a digital sick note -->
            <span v-else>
              Digital AU
            </span>
          </td>
          <td>
            <a class="btn btn-danger" @click="deleteIllness(illness.id)">Löschen</a>
          </td>
        </tr>
      </table>
      <div>
      </div>
    </div>
    <div v-else>
      Keine Krankheiten gefunden.
    </div>
  </div>
</template>

<style>
.home {
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>

<script>
import axios from "axios";
import moment from "moment";


export default {
  components: {
  },
  name: "illnesses",
  data() {
    return {
      illnesses: [],
      moment: moment
    };
  },
  methods: {
    deleteIllness: function (illnessId) {
      axios({ method: "DELETE", "url": process.env.VUE_APP_API_PATH + "illnesses/" + illnessId })
        .then(result => {
          var indexToRemove = -1;
          for (var i = 0; i < this.illnesses.length; i++) {
            if (this.illnesses[i].id == illnessId) {
              indexToRemove = i;
            }
          }
          this.illnesses.splice(indexToRemove, 1);
        }, error => {
          console.error(error);
        });
    },
    downloadfile: function (illnessId, filePath) {
      axios({ method: "GET", "url": process.env.VUE_APP_API_PATH + "illnesses/GetFile/" + illnessId, responseType: 'arraybuffer' })
        .then(result => {
          let blob = new Blob([result.data], { type: 'application/pdf' })
          let link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = filePath
          link.click()
          URL.revokeObjectURL(link.href)
        }, error => {
          console.error(error);
        });
    }
  },
  mounted() {
    axios({ method: "GET", url: process.env.VUE_APP_API_PATH + "illnesses/get" }).then(result => {
      this.illnesses = result.data;
    }, error => {
      console.error(error);
      if (error.response.status == 401) {
        this.$router.push("/");
      }
    });
  }
};


</script>
